import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ApiService } from '@core/api.service';
import { CrudHttpService, CrudService } from 'collection';
import { Item, ItemModel, PostEntityModel } from 'collection';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private _isOpenSidebar: BehaviorSubject<boolean> = new BehaviorSubject(true);
  tokenRefresh: PostEntityModel;
  tokenRetrieve: PostEntityModel;

  profileItem: ItemModel;
  accountSettingsItem: ItemModel;
  licensesInfoItem: ItemModel;
  isOpenSidebar = true;
  accountSettings$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  emailHasToBeFocused: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private _httpService: CrudHttpService,
    private _api: ApiService,
    private _crud: CrudService
  ) {
    this.profileItem = new Item({
      api: this._api.userMyProfile,
      params: {
        expand: 'role,status,country,language'
      }
    });
    this.accountSettingsItem = new Item({
      api: this._api.accountSettings,
      params: {
        expand: 'country,language,currency,length_unit,region,modules'
      }
    });
    this.licensesInfoItem = new Item({
      api: this._api.accountInfo
    });

    this.tokenRefresh = this._crud.createPostEntity({ name: 'external-token/refresh' });
    this.tokenRetrieve = this._crud.createPostEntity({ name: 'external-token/retrieve' });
  }

  get $isOpenSidebar(): Observable<boolean> {
    return this._isOpenSidebar.asObservable();
  }

  toggleSidebar(): boolean {
    this.isOpenSidebar = !this.isOpenSidebar;
    this._isOpenSidebar.next(this.isOpenSidebar);
    return this.isOpenSidebar;
  }

  uploadAvatar(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('avatar', file);

    return this._httpService.post({
      url: environment.apiUrl + '/v1/avatar',
      data: formData
    });
  }

  deleteAvatar(): Observable<any> {
    return this._httpService.delete({ url: environment.apiUrl + '/v1/user/profile-photo' });
  }

  uploadLogoAccount(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('logo', file);

    return this._httpService.post({
      url: environment.apiUrl + '/v1/account/upload-logo',
      data: formData
    });
  }

  getAccountSettings(clear = false): Observable<any> {
    if (this.accountSettings$.value && !clear) {
      return this.accountSettings$;
    }

    return this.accountSettingsItem.load().pipe(
      take(1),
      map((res) => {
        this.accountSettings$.next(res);
        return res;
      })
    );
  }
}
